import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin, Subscription, tap } from 'rxjs';
import { generateUUID } from 'src/app/core/generators/generateUUID';
import {
  CadastrarServicoBodyModel,
  IEditServico,
  IGetServicoById
} from 'src/app/services/ServicoService/servico.model';
import { ServicoService } from 'src/app/services/ServicoService/servico.service';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';
import Swal from 'sweetalert2';

interface IOptions {
  name: string;
  value: number;
}

@Component({
  selector: 'app-cadastro-servico',
  templateUrl: './cadastro-servico.component.html',
  styleUrls: ['./cadastro-servico.component.scss']
})
export class CadastroServicoComponent implements OnInit {
  private subscription$ = new Subscription();
  form: FormGroup;
  activeRoute: string = '';
  isEditing: boolean = false;
  isLoading: boolean = false;
  pkServico: number = 0;
  disabledServico: boolean = false;
  title: string = 'Cadastro Serviço';
  guid = generateUUID();

  servicoOptions: IOptions[] = [
    {
      name: 'Sim',
      value: 1
    },
    {
      name: 'Não',
      value: 0
    }
  ];

  caixaOptions: IOptions[] = [
    { name: 'Pátio', value: 1 },
    { name: 'Serviços', value: 2 }
  ];

  eventoOptions: IOptions[] = [
    { name: 'Entrada', value: 1 },
    { name: 'Laudo', value: 2 }
  ];

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private cd: ChangeDetectorRef,
    private servicoService: ServicoService,
    public swalAlert: SwalAlertService
  ) {
    this.form = this.initForm();
  }

  ngOnInit(): void {
    this.obterDados();
  }

  initForm(): FormGroup {
    const form = this.fb.group({
      TX_TIPO_SRVC: [null, Validators.required],
      FL_AGND: [null, Validators.required],
      FL_CPTM: [null, Validators.required],
      FL_TOTL_EIXO: [null, Validators.required],
      FL_TIPO_CRRT: [null, Validators.required],
      FL_CRGA: [null, Validators.required],
      NU_CAIX_SRVC: [null, Validators.required],
      NU_EVNT_SRVC: [{ value: null, disabled: true }]
    });
    return form;
  }

  obterDados() {
    this.subscription$.add(
      forkJoin([this.getServico()]).subscribe(() => {
        this.route.queryParams.subscribe(params => {
          if (params && Object.keys(params).length > 0) {
            this.title = 'Editar Serviço';
            this.isEditing = true;
            this.disabledServico = false;

            this.servicoService
              .GetServicoById(Number(params['codigo']))
              .subscribe((response: IGetServicoById) => {
                this.pkServico = response.PK_SRVC;
                this.form.controls['TX_TIPO_SRVC'].setValue(
                  response.TX_TIPO_SRVC ?? ''
                );
                if (response.NU_CAIX_SRVC) {
                  this.form.controls['NU_CAIX_SRVC'].setValue(response.NU_CAIX_SRVC);
                  this.checkEventoStatus(response.NU_CAIX_SRVC);
                }
                if (response.NU_EVNT_SRVC) {
                  this.form.controls['NU_EVNT_SRVC'].setValue(response.NU_EVNT_SRVC);
                }
              });

            const booleanFields = [
              'FL_AGND',
              'FL_CPTM',
              'FL_TOTL_EIXO',
              'FL_TIPO_CRRT',
              'FL_CRGA'
            ];

            booleanFields.forEach(field => {
              if (params[field] !== undefined) {
                this.form.controls[field].setValue(
                  params[field] === 'true' ? 1 : 0
                );
              }
            });

            if (params['modoServico'] === 'Visualizar') {
              this.title = 'Visualizar Serviço';
              this.form.disable();
              this.disabledServico = true;
            }
          }
        });
      })
    );
  }

  postarDados() {
    let payload = this.createPayload();
    this.isLoading = true;
    if (!this.form.valid) {
      this.isLoading = false;
      this.swalAlert.showAlert(
        'Atenção!',
        'Verifique se todos os campos obrigatórios foram preenchidos corretamente.',
        'warning'
      );
      return;
    }

    if (this.title.includes('Editar')) {
      this.isEditing = true;
      this.isLoading = true;
      payload = { ...payload, NU_STTS_SRVC: 1 };

      this.servicoService.EditarServico(this.pkServico, payload).subscribe(
        response => {
          this.isLoading = false;
          this.router.navigate(['listagem/servico']);
        },
        error => {
          this.isLoading = false;
        }
      );
      return;
    }

    this.isEditing = false;
    this.isLoading = true;
    this.servicoService.CreateServico(payload, this.guid).subscribe(
      response => {
        this.isLoading = false;
        this.router.navigate(['listagem/servico']);
      },
      error => {
        this.isLoading = false;
      }
    );
  }

  createPayload(): CadastrarServicoBodyModel | IEditServico {
    return {
      TX_TIPO_SRVC: this.form.controls['TX_TIPO_SRVC'].value,
      FL_AGND: this.form.controls['FL_AGND'].value == 1 ? true : false,
      FL_CPTM: this.form.controls['FL_CPTM'].value == 1 ? true : false,
      FL_TOTL_EIXO:
        this.form.controls['FL_TOTL_EIXO'].value == 1 ? true : false,
      FL_TIPO_CRRT:
        this.form.controls['FL_TIPO_CRRT'].value == 1 ? true : false,
      FL_CRGA: this.form.controls['FL_CRGA'].value == 1 ? true : false,
      NU_CAIX_SRVC: this.form.controls['NU_CAIX_SRVC'].value,
      NU_EVNT_SRVC: this.form.getRawValue().NU_EVNT_SRVC
    };
  }

  getServico() {
    this.isLoading = true;
    return this.servicoService.GetServico().pipe(
      tap(response => {
        this.isLoading = false;
      })
    );
  }

  exibirMensagem(mensagem: string, type: 'success' | 'error') {
    const config: MatSnackBarConfig = {
      duration: 3000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: type === 'success' ? ['snackbar-success'] : ['snackbar-error']
    };

    this.snackBar.open(mensagem, 'Fechar', config);
  }

  public goTo(route: string) {
    this.router.navigate([route]);
    setTimeout(() => {
      this.activeRoute = this.router.url;
      this.cd.detectChanges();
    }, 200);
  }

  onSelectChange(event: number, name: string) {
    this.form.controls[name].setValue(event);

    if (name === 'NU_CAIX_SRVC') {
      this.checkEventoStatus(event);
    }
  }

  checkEventoStatus(caixaValue: number) {
    if (caixaValue == 2) {
      // Serviços
      this.form.controls['NU_EVNT_SRVC'].enable();
      this.form.controls['NU_EVNT_SRVC'].setValidators([Validators.required]);
    } else {
      this.form.controls['NU_EVNT_SRVC'].disable();
      this.form.controls['NU_EVNT_SRVC'].setValue(null);
      this.form.controls['NU_EVNT_SRVC'].clearValidators();
    }
    this.form.controls['NU_EVNT_SRVC'].updateValueAndValidity();
  }
}
